import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useU2000AuthContext } from "../../context/auth/U2000UseAuthContext";
import type { FC } from "react";

const U2000RequireAuth: FC = () => {
  const { auth } = useU2000AuthContext();
  const location = useLocation();

  return auth?.isAuthenticated ? <Outlet /> : <Navigate to="/U2001" state={{ from: location.pathname }} />;
};

export default U2000RequireAuth;
